import React from 'react';
import omit from 'lodash/omit';

import './style.scss';
import { PhotoGalleryButtonCSS, PhotoGalleryImageCSS } from 'app/shared/modules/photo-gallery/PhotoGalleryImage/styles';

type PhotoData = {
  intersectionObserver: IntersectionObserver;
  src?: string;
  alt?: string;
  [key: string]: unknown;
};

type PhotoGalleryImageProps = {
  index: number;
  onClick: (e: React.MouseEvent, data: { index: number; photo: PhotoData }) => void;
  photo: PhotoData;
  height?: number;
  width?: number;
};

class PhotoGalleryImage extends React.Component<PhotoGalleryImageProps> {
  ref: React.RefObject<HTMLImageElement>;
  observer: IntersectionObserver;

  constructor(props: PhotoGalleryImageProps) {
    super(props);

    this.ref = React.createRef();
    this.observer = this.props.photo.intersectionObserver;
  }

  componentDidMount() {
    if (this.ref.current) {
      this.observer.observe(this.ref.current);
    }
  }

  componentWillUnmount() {
    if (this.ref.current) {
      this.observer.unobserve(this.ref.current);
    }
  }

  render() {
    const { index, onClick, photo } = this.props;

    const photoProps = omit(photo, ['intersectionObserver']);

    return (
      <button className={PhotoGalleryButtonCSS} onClick={(e) => onClick(e, { index, photo })}>
        <img className={PhotoGalleryImageCSS} ref={this.ref} {...photoProps} />
      </button>
    );
  }
}

export default PhotoGalleryImage;
